import { ArrowRight } from 'lucide-react';

import { PrimaryCTA } from '../components/PrimaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';
import { StepCard } from '../components/StepCard';
import { MARKETING_APP_ENTRY_HREF } from '../marketingContent';

import styles from './HowItWorksSection.module.css';

const steps = [
  {
    body: "Email, name, institute. Confirm and you're in.",
    label: 'STEP 01',
    linkHref: MARKETING_APP_ENTRY_HREF,
    linkLabel: '2 minutes →',
    title: 'Create your free account.',
  },
  {
    body: 'Browse our catalog by subject. Open any course and look around — full content, real homework, working AI tutor.',
    label: 'STEP 02',
    title: 'Pick a pre-built course.',
  },
  {
    body: "Share your course link. Adjust the schedule, customize content if you want, and you're live.",
    label: 'STEP 03',
    title: 'Start teaching.',
  },
] as const;

export function HowItWorksSection() {
  return (
    <SectionWrapper background="soft" data-testid="faculty-section-how-it-works">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>HOW IT WORKS</p>
          <h2 className={styles.title}>From signup to teaching, in three steps.</h2>
          <p className={styles.subhead}>
            Most instructors are running their class within an afternoon. No
            sales call. No procurement forms. No credit card.
          </p>
        </div>

        <div className={styles.grid}>
          {steps.map((step) => (
            <StepCard key={step.label} {...step} />
          ))}
        </div>

        <div className={styles.actions}>
          <PrimaryCTA
            href={MARKETING_APP_ENTRY_HREF}
            icon={<ArrowRight aria-hidden="true" size={16} />}
            label="Start a free course"
          />
        </div>
      </div>
    </SectionWrapper>
  );
}
